import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Typography } from "@mui/material"

import useAppStore from "store/app"
import useAlertStore from "store/alert"

import Layout from "./Layout"
import Password from "../../shared/fields/Password"
import PasswordConfirmation from "../../shared/fields/PasswordConfirmation"
import BackButton from "../../shared/buttons/BackButton"
import SecondaryButton from "../../shared/buttons/SecondaryButton"
import useTranslation from "../../../hooks/use_translation"

const PersonalDataPassword = () => {
  const fields = useAppStore((state) => state.fields)
  const resetFields = useAppStore((state) => state.resetFields)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)
  const updatePassword = useAppStore((state) => state.updatePassword)
  const showAlert = useAlertStore((state) => state.showAlert)

  const t = useTranslation()

  const navigate = useNavigate()

  useEffect(() => {
    resetFields()
  }, [])

  const handleSubmit = (event) => {
    event.preventDefault()

    if (fields.password.input_value !== fields.password_confirmation.input_value) {
      updateFieldErrorMessage(
        "password_confirmation",
        t?.fields?.password_confirmation_error_not_match,
      )
      return
    }

    let valid = true

    const errorsCheck = ["password"]

    errorsCheck.map((field) => {
      if (!fields[field]?.touched) {
        valid = false
        updateFieldErrorMessage(field, t?.fields?.required)
      }

      if (fields[field].error_message !== "") {
        valid = false
      }
    })

    if (!valid) return

    const params = {
      password: fields.password?.input_value,
    }

    updatePassword(params)
      .then(() => {
        showAlert("Successfully updated", "success")

        navigate("/me/personal_data")
      })
      .catch((error) => showAlert(error.message, "error"))
  }

  return (
    <Layout>
      <BackButton text={t?.pages?.change_password?.back_btn} />
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
        {t?.pages?.change_password?.title}
      </Typography>

      <Password />
      <PasswordConfirmation />

      <SecondaryButton
        fullWidth
        text={t?.pages?.change_password?.confirm_btn}
        onClick={handleSubmit}
      />
    </Layout>
  )
}

export default PersonalDataPassword
